<div class="flex flex-col flex-auto min-w-0">
    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <div class="">


            <div class="flex items-center justify-between w-full ">
                <h2 class="text-3xl font-semibold tracking-tight leading-8">
                    {{ "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PAGE_HAEDER" | translate }}
                </h2>


                <div>
                    <button class="back-button" routerLink="/purchase-order">
                        {{
                        "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.BUTTONS.BACK_TO_PO"
                        | translate
                        }}
                    </button>
                </div>
            </div>

            <div>
                <h2 class="page-sub-header">
                    {{ "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PAGE_SUB_HEADER" | translate }}
                </h2>
            </div>


        </div>
        <div class="content">
            <!--   <div
                *ngIf="showSuccessMessage"
                style="
                    background-color: greenyellow;
                    z-index: 1000;
                    position: fixed;
                    padding: 10px;
                    height: 40px;
                    display: block;
                    right: 30px;
                    top: 70px;
                "
            >

                {{
                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.SHOW_MESSAGES.PO_SAVE"
                        | translate
                }}
            </div>

            <div
                *ngIf="showPoUpdateSuccessMessage"
                style="
                    background-color: greenyellow;
                    z-index: 1000;
                    position: fixed;
                    padding: 10px;
                    height: 40px;
                    display: block;
                    right: 30px;
                    top: 70px;
                "
            >

                {{
                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.SHOW_MESSAGES.PO_UPDATE"
                        | translate
                }}
            </div>


            <div
                *ngIf="showErrorMessage"
                style="
                    background-color: rgb(255, 64, 47);
                    z-index: 1000;
                    position: fixed;
                    padding: 10px;
                    height: 40px;
                    display: block;
                    right: 30px;
                    top: 70px;
                "
            >

                {{
                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.SHOW_MESSAGES.PO_SAVE_ERROR"
                        | translate
                }}
            </div>
           <div
                *ngIf="showPoItemDeletedMessage"
                style="
                    background-color: greenyellow;
                    z-index: 1000;
                    position: fixed;
                    padding: 10px;
                    height: 40px;
                    display: block;
                    right: 30px;
                    top: 70px;
                "
            >
                {{
                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.SHOW_MESSAGES.PO_ITEM_DELETE"
                        | translate
                }}
            </div> -->

            <div>
                <form [formGroup]="orderForm">
                    <div>
                        <div fxLayout="row">
                            <mat-form-field appearance="outline" class="pr-4 orderInputForm">
                                <mat-label>{{
                                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.PO_NUMBER"
                                    | translate
                                    }}</mat-label>
                                <input matInput formControlName="poNumber" />
                                <!-- <mat-icon
                                    matSuffix
                                    matTooltip="{{
                                        'PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.FORM_DESCRIPTION.PO_NUMBER'
                                            | translate
                                    }}"
                                >
                                    information
                                </mat-icon> -->
                            </mat-form-field>
                            &nbsp;
                            <mat-form-field appearance="outline" class="pr-4 orderInputForm">
                                <mat-label>{{
                                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.REFERENCE_NUMBER"
                                    | translate
                                    }}</mat-label>
                                <input matInput formControlName="referenceNumber" />
                                <!-- <mat-icon
                                    matSuffix
                                    matTooltip="{{
                                        'PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.FORM_DESCRIPTION.REFERENCE_NUMBER'
                                            | translate
                                    }}"
                                >
                                    information
                                </mat-icon> -->
                            </mat-form-field>

                            &nbsp;
                        </div>

                        <div fxLayout="row">
                            <mat-form-field appearance="outline" class="pr-4 orderInputForm">
                                <mat-label>{{
                                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.MANUFACTURE_NAME"
                                    | translate
                                    }}</mat-label>
                                <input matInput [matAutocomplete]="auto" (keyup)="onManufacturerSearch($event)"
                                    formControlName="manufacturerName" />
                                <!-- <mat-icon
                                    matSuffix
                                    matTooltip="{{
                                        'PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.FORM_DESCRIPTION.MANUFACTURE_NAME'
                                            | translate
                                    }}"
                                >
                                    information
                                </mat-icon> -->
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="
                                            let manufacturer of manufacturerList
                                        " (click)="
                                            onManufacturerSelect(manufacturer)
                                        " [value]="manufacturer">
                                        {{ manufacturer }}
                                    </mat-option>
                                    <mat-option></mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            &nbsp;
                            <mat-form-field appearance="outline" class="pr-4 orderInputForm">
                                <mat-label>{{
                                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.SUPPLIER_NAME"
                                    | translate
                                    }}</mat-label>
                                <input matInput [matAutocomplete]="supplierSelectauto"
                                    (keyup)="onSupplierSearch($event)" formControlName="supplierName" />
                                <!-- <mat-icon
                                    matSuffix
                                    matTooltip="{{
                                        'PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.FORM_DESCRIPTION.SUPPLIER_NAME'
                                            | translate
                                    }}"
                                >
                                    information
                                </mat-icon> -->
                                <mat-autocomplete #supplierSelectauto="matAutocomplete">
                                    <mat-option *ngFor="let supplier of supplierList" [value]="supplier">
                                        {{ supplier }}
                                    </mat-option>
                                    <mat-option></mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field class="pr-4 orderInputForm" appearance="outline">
                                <input matInput readonly formControlName="poDate" [matDatepicker]="dp1" placeholder="{{
                                        'PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.PO_DATE'
                                            | translate
                                    }}" />
                                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                                <mat-datepicker #dp1 disabled="false"></mat-datepicker>
                            </mat-form-field>
                            &nbsp;
                            <mat-form-field appearance="outline" class="pr-4 orderInputForm">
                                <mat-label>{{
                                    "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.APPROVED_BY"
                                    | translate
                                    }}</mat-label>
                                <input matInput formControlName="approvedBy" />
                                <!-- <mat-icon
                                    matSuffix
                                    matTooltip="{{
                                        'PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_FORM.FORM_DESCRIPTION.APPROVED_BY'
                                            | translate
                                    }}"
                                >
                                    information
                                </mat-icon> -->
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-primary" (click)="addItem()">
                            {{
                            "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.BUTTONS.ADD_FORMULA"
                            | translate
                            }}
                        </button>
                    </div>
                    &nbsp;
                    <div formArrayName="poItems">
                        <div *ngFor="
                                let poItem of getPoItemControl.controls;
                                let i = index
                            ">
                            <div [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <mat-label>{{
                                        "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_ITEM_FORM.FORMULA_NAME"
                                        | translate
                                        }}</mat-label>
                                    <input matInput [matAutocomplete]="auto" (keyup)="
                                            onFormulaSearch($event);
                                            onNonDbFormulaAdded(
                                                $event.target.value,
                                                poItem
                                            )
                                        " formControlName="formulaName" />
                                    <!-- <mat-icon
                                        matSuffix
                                        matTooltip="{{
                                            'PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_ITEM_FORM.FORMULA_NAME'
                                                | translate
                                        }}"
                                    >
                                        information
                                    </mat-icon> -->
                                    <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option *ngFor="let formula of formulaList" (click)="
                                                onFormulaSelect(formula, poItem)
                                            " [value]="formula.name">
                                            {{ formula.name }}
                                        </mat-option>
                                        <mat-option> </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>

                                &nbsp;

                                <mat-form-field appearance="outline" class="pr-4 pl-4">
                                    <mat-label>{{
                                        "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_ITEM_FORM.QUANTITY"
                                        | translate
                                        }}</mat-label>
                                    <input matInput type="number" formControlName="quantity" />
                                    <!-- <mat-icon
                                        matSuffix
                                        matTooltip="{{
                                            'PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_ITEM_FORM.QUANTITY'
                                                | translate
                                        }}"
                                        >information
                                    </mat-icon> -->
                                </mat-form-field>

                                &nbsp;
                                <mat-form-field appearance="outline" class="pr-4">
                                    <mat-label>{{
                                        "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_ITEM_FORM.UNIT"
                                        | translate
                                        }}</mat-label>
                                    <mat-select placeholder="U/M" formControlName="unit">
                                        <mat-option [value]="pOUnitEnum.KG">
                                            {{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.KG"
                                            | translate
                                            }}
                                        </mat-option>
                                        <mat-option [value]="pOUnitEnum.TONNE">
                                            {{
                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.TONNE"
                                            | translate
                                            }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                &nbsp;

                                <mat-form-field appearance="outline" class="pr-4">
                                    <mat-label>{{
                                        "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.PO_ITEM_FORM.ZDHC_MRSL"
                                        | translate
                                        }}</mat-label>
                                    <input matInput formControlName="zdhcMrsl" readonly />
                                </mat-form-field>

                                &nbsp; &nbsp;
                                <!-- <mat-icon *ngIf="i==0" (click)="addItem()">add</mat-icon> -->
                                <mat-icon *ngIf="i != 0 && !isUpdate" (click)="deleteItem(i)">delete</mat-icon>
                                <mat-icon *ngIf="isUpdate" (click)="deletePOItem(i, poItem)">delete</mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="m-8" style="text-align: right">
                        <button *ngIf="!isUpdate" class="btn btn-default" [disabled]="orderForm.invalid"
                            (click)="savePo(orderForm.value)">
                            {{
                            "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.BUTTONS.PO_SAVE"
                            | translate
                            }}
                        </button>
                        <button *ngIf="isUpdate" [disabled]="orderForm.invalid" class="btn btn-default"
                            (click)="updatePo(orderForm.value)">
                            {{
                            "PURCHASE_ORDER_MODULE.ADD_PO_COMPONENT.BUTTONS.PO_UPDATE"
                            | translate
                            }}
                        </button>
                    </div>
                </form>
            </div>

            <ngx-loading [show]="isLoading"></ngx-loading>
        </div>
    </div>
</div>